import { applyDeploymentMarks } from "./modules/deployment.js";
import { initPwa } from "./modules/pwa.js";
import { armSentry, initSentry } from "./modules/sentry.js";
import { initFontSize } from "./modules/font-size.js";
import { initTheme } from "./modules/theme.js";
import { boot } from "./boot";

// Als Allererstes, noch vor dem Zeichnen: Ab hier geht kein Fehler mehr
// verloren, auch nicht in der Zeit, in der Sentry selbst noch geladen wird.
armSentry();
// Bewusst **nicht** abgewartet. Die Oberfläche darf nicht auf die
// Fehlerüberwachung warten — die Ereignisse davor liegen ohnehin auf Halde.
// Ob aufgezeichnet wird (Session Replay, nie auf /shared/<token>), entscheidet
// modules/sentry-replay.ts beim Start.
void initSentry();

initTheme();
initFontSize();
initPwa();
// Ein anderes Symbol in den Tab, wenn dies nicht die Produktion ist. Ebenfalls
// nicht abgewartet — es hängt an `/api/config`, und die Oberfläche wartet auf
// keine Auskunft, die nur ein Etikett entscheidet.
void applyDeploymentMarks();

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => { void boot(); });
else void boot();
